import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { LinkButton } from '../link-button/link-button.js';
import { LinkIconButton } from '../link-icon-button/link-icon-button.js';
import { LinkPrimitive } from '../link-primitive/link-primitive.js';
import { link } from './link.css.js';

/**
 * A styled inline link component.
 *
 * @see https://fpl.figma.design/components/links/link/
 */
const Link = Object.assign(
// This is an edge case where the lint rule can't detect that we are setting a displayName
// eslint-disable-next-line react/display-name
forwardRef((props, ref) => (jsx(LinkPrimitive, { "data-fpl-component": "", ...props, ref: ref, className: link }))), { Button: LinkButton, IconButton: LinkIconButton });
Link.displayName = 'Link';

export { Link };
//# sourceMappingURL=link.js.map
